export class FunctionFilter {
    functionId: number;
    fromValue?: any;
    toValue?: any;
}

export class ReferenceSearchParams {
    page: number;
    pageSize: number;
    categoryId?: any;
    referenceId?: any;
    isPublished?: any;
    searchText?: any;
    languageCode: string;
    functionResponseValues: number[];
    functionFilters: FunctionFilter[];
}
